// extracted by mini-css-extract-plugin
export default {"webGisPage":"WebGis_webGisPage__WuRP9","mapContainer":"WebGis_mapContainer__ImHvW"};